import { render, staticRenderFns } from "./ItemGroups.vue?vue&type=template&id=813e59c6&scoped=true&lang=html&"
import script from "./ItemGroups.vue?vue&type=script&lang=js&"
export * from "./ItemGroups.vue?vue&type=script&lang=js&"
import style0 from "./ItemGroups.vue?vue&type=style&index=0&id=813e59c6&prod&lang=css&"
import style1 from "./ItemGroups.vue?vue&type=style&index=1&id=813e59c6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813e59c6",
  null
  
)

export default component.exports